import React, { useState } from 'react';
import { BaseButton, Icon } from '@common/components';
import { Checkbox, Dropdown } from 'antd';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import { ItemType } from 'antd/lib/menu/hooks/useItems';

type SelectColumnsDropdownProps = {
  allColumns: {
    key: string;
    title: string;
  }[];
  defaultColumnsKeys: CheckboxValueType[];
  onChange: (selectedColumnsKeys: CheckboxValueType[]) => void;
};

export function SelectColumnsDropdown({
  allColumns,
  onChange,
  defaultColumnsKeys,
}: SelectColumnsDropdownProps) {
  const [open, setOpen] = useState(false);

  const items = allColumns.map((column) => {
    return {
      key: column.key,
      label: <Checkbox value={column.key}>{`${column.title}`}</Checkbox>,
    } as ItemType;
  });

  return (
    <Dropdown
      className="wk-select-columns-dropdown"
      open={open}
      onOpenChange={setOpen}
      menu={{ items }}
      dropdownRender={(menu) => (
        <div>
          <Checkbox.Group onChange={onChange} defaultValue={defaultColumnsKeys}>
            {menu}
          </Checkbox.Group>
        </div>
      )}
    >
      <BaseButton icon={<Icon icon="columns3" size="md" kind="light" />}>
        Columns
        <Icon icon="chevronDown" size="sm" kind="regular" color="steelDarker" />
      </BaseButton>
    </Dropdown>
  );
}
